var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDevicesListIcon = function SvgDevicesListIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1650_145433)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 28,
    height: 28,
    rx: 7,
    fill: "url(#paint0_linear_1650_145433)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3333,
    cy: 27.0007,
    rx: 8.33333,
    ry: 0.666667,
    fill: "#525252",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7.66797,
    width: 16,
    height: 5.05263,
    rx: 0.842105,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5087,
    cy: 10.1937,
    r: 0.842105,
    fill: "#00BFA5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3334,
    y: 9,
    width: 2.66667,
    height: 2.66667,
    rx: 0.666667,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13.3867,
    width: 16,
    height: 5.05263,
    rx: 0.842105,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5087,
    cy: 15.9124,
    r: 0.842105,
    fill: "#00BFA5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3334,
    y: 14.7188,
    width: 2.66667,
    height: 2.66667,
    rx: 0.666667,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 19.1055,
    width: 16,
    height: 5.05263,
    rx: 0.842105,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5087,
    cy: 21.6312,
    r: 0.842105,
    fill: "#00BFA5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3334,
    y: 20.4375,
    width: 2.66667,
    height: 2.66667,
    rx: 0.666667,
    fill: "#E4E4E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1650_145433",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1650_145433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1650_145433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1650_145433",
    x1: 9,
    y1: -0.999999,
    x2: 78.3333,
    y2: 77.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04FFA5"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDevicesListIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "devices-list-icon.7184558f4c5405e4c10c3bd11d72cecc.svg";